import { HeatConsumptionResponse } from '../models/household-data';

export function mapToHeatConsumptionResponse(raw: any): HeatConsumptionResponse {
  return {
    houseId: raw.houseId,
    householdUserId: raw.householdUserId,
    heatConsumpion: {
      pointsFrequency: raw.heatConsumpion.pointsFrequency,
      telemetry: raw.heatConsumpion.telemetry.map((t: any) => ({
        name: t.name,
        secondaryName: t.secondaryName,
        lineColour: t.lineColour,
        lineId: t.lineId,
        unit: t.unit,
        measurementTypeId: t.measurementTypeId,
        timestamps: t.timestamps.map((ts: string) => new Date(ts)),
        values: t.values,
        currentValue: t.currentValue,
      }))
    },
    surname: raw.surname,
    lastname: raw.lastname,
    street: raw.street,
    houseNumber: raw.houseNumber,
    postcode: raw.postcode,
    flatNumber: raw.flatNumber,
    contractNumber: raw.contractNumber,
  };
}
